module.exports = __webpack_public_path__ + "img/cast-w.svg";